var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.753 11.201 12.42 2.141a.679.679 0 0 0-.827 0L.258 11.2c-.294.241-.347.642-.107.936.134.16.32.24.534.24a.884.884 0 0 0 .426-.133L12.02 3.53l10.908 8.714c.293.24.72.187.933-.107a.679.679 0 0 0-.107-.936Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.54 11.656a.661.661 0 0 0-.667.668v8.34h-3.387v-3.608c0-1.925-1.573-3.502-3.494-3.502-1.92 0-3.493 1.577-3.493 3.502v3.608h-3.36v-8.34a.661.661 0 0 0-.667-.668.661.661 0 0 0-.667.668v9.008c0 .374.293.668.667.668h4.694a.661.661 0 0 0 .666-.668v-4.277c0-1.202.96-2.165 2.16-2.165 1.2 0 2.16.963 2.16 2.165v4.277c0 .374.294.668.667.668h4.72a.661.661 0 0 0 .667-.668v-9.008a.678.678 0 0 0-.666-.668Z",
    fill: "#fff"
  })));
};

export default SvgHome;